import styled from "styled-components/macro";

export const Layout = styled.div`
  width: 100%;
  height: 100%;
`;

export const Content = styled.div`
  width: 100%;
  height: 100%;
`;
